import { IndianRupee, TrendingUp, ShieldCheck, PackageCheck, UserRound } from "lucide-react";
import { Reveal, MaskLine, Eyebrow } from "./motion";


const PILLARS = [
    {
        n: "01",
        icon: IndianRupee,
        title: "Direct Wholesale Rates",
        desc: "Straight from Kanpur’s textile hub — honest wholesale pricing, no middlemen margins.",
    },
    {
        n: "02",
        icon: TrendingUp,
        title: "Latest Trends, Every Season",
        desc: "Fresh designs landing regularly, curated for what families are actually buying.",
    },
    {
        n: "03",
        icon: ShieldCheck,
        title: "Quality You Can Sell",
        desc: "Best-quality stock, checked before it leaves the shop — it sells itself on your shelves.",
    },
    {
        n: "04",
        icon: PackageCheck,
        title: "Bulk-Ready Stock",
        desc: "Deep sizes and colours so your orders never run half-empty.",
    },
    {
        n: "05",
        icon: UserRound,
        title: "Direct Connect",
        desc: "One direct line for orders, sizes & queries — call or WhatsApp us anytime.",
    },
];

export default function Pillars() {
    return (
        <section id="why" data-testid="why-section" className="relative overflow-hidden bg-maroon-900 py-24 lg:py-32">
            <span
                className="pointer-events-none absolute -right-8 top-4 select-none font-hindi leading-none text-gold/[0.05]"
                style={{ fontSize: "clamp(9rem, 20vw, 19rem)" }}
                aria-hidden="true"
            >
                थोक
            </span>

            <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
                <div className="max-w-3xl">
                    <Reveal>
                        <Eyebrow>Why Baba Garments</Eyebrow>
                    </Reveal>
                    <h2 className="mt-4 font-display text-4xl font-bold leading-[1.02] tracking-tight text-cream sm:text-5xl lg:text-6xl">
                        <MaskLine>Built for Retailers</MaskLine>
                        <MaskLine delay={0.1} className="italic font-light text-gold">
                            &amp; Bulk Buyers.
                        </MaskLine>
                    </h2>
                    <Reveal delay={0.2}>
                        <p className="mt-5 max-w-xl text-base leading-relaxed text-cream/65 sm:text-lg">
                            Complete family fashion stock, direct wholesale rates and trends your
                            customers ask for — that is the Baba Garments promise.
                        </p>
                    </Reveal>
                </div>

                <div className="mt-16 border-b border-gold/15">
                    {PILLARS.map((p, i) => (
                        <Reveal key={p.n} delay={i * 0.06} y={22}>
                            <div
                                data-testid={`pillar-row-${p.n}`}
                                className="group grid grid-cols-[auto_1fr] items-center gap-x-6 gap-y-3 border-t border-gold/15 py-7 transition-colors duration-300 hover:bg-maroon-800/60 sm:px-6 md:grid-cols-[80px_minmax(0,1fr)_minmax(0,380px)_64px] lg:px-8"
                            >
                                <span className="font-display text-xl italic text-gold/80">{p.n}</span>
                                <h3 className="font-display text-2xl font-bold text-cream md:text-[1.7rem]">
                                    {p.title}
                                </h3>
                                <p className="col-span-2 max-w-md text-sm leading-relaxed text-cream/65 md:col-span-1">
                                    {p.desc}
                                </p>
                                <span className="col-span-2 flex h-14 w-14 items-center justify-center rounded-full border border-gold/30 text-gold transition-colors duration-300 group-hover:bg-gold group-hover:text-maroon-950 md:col-span-1">
                                    <p.icon size={22} strokeWidth={1.7} />
                                </span>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}